// EAUG-77: the edit link is https://eauget.com/votre-soiree-approche/?mode=edit&token=<edit token>,
// and Stripe returns to it with &paid=<modification id>. The WordPress page
// forwards its whole query string to this iframe.

export interface EditEntry {
  token: string;
  paidId: number | null;
}

/** The `paid` parameter of a Stripe success URL, or null. */
export function readPaidId(search: string): number | null {
  const raw = new URLSearchParams(search).get('paid');
  if (raw === null || !/^\d+$/.test(raw)) return null;
  const id = Number(raw);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
}

/** The edit page's entry when the URL is an edit link; null for the wizard. */
export function readEditEntry(search: string): EditEntry | null {
  const params = new URLSearchParams(search);
  if (params.get('mode') !== 'edit') return null;
  return { token: params.get('token') ?? '', paidId: readPaidId(search) };
}
